import api from './apiClient';
import { setTokens, clearTokens, getRefreshToken } from '../utils/tokenUtils';

export interface User {
  id: number;
  role: 'ADMIN' | 'BROADCASTER' | 'STREAMR' ;
  email: string;
  streamName: string; // This will likely become a "primary" channel name or be deprecated
  alwaysRecord: boolean;
  phone: string | null;
  altPhone: string | null;
  accountStatus: 'AWAITING_REVIEW' | 'PENDING_APPROVAL' | 'REJECTED' | 'TRIAL' | 'TRIAL_EXPIRED' | 'ACTIVE' | 'GRACE_PERIOD' | 'PAST_DUE' | 'DISABLED' | 'SUSPENDED' | 'CANCELLED';
  accountStatusBeforeRestriction?: string | null;
  createdAt: string;
  trialExpiresAt: string | null;
  billingCycleEndsAt: string | null;
  streamKeyPin: string | null;
  setupFeePaid: boolean;
  billingCycle: string; 
  currency: string;
  canModifySubscription: boolean;
  hasSecurityPin: boolean;
  firstName: string | null;
  lastName: string | null;
  city: string | null;
  postalCode: string | null;
  country: string | null;
  unreadNotificationCount: number;
  platformLimit: number | null;
  channelLimit: number | null;
  outputLimit: number | null;
  cpuLimit: number | null;
  // ADD THESE TWO LINES
  hlsLimit: number | null;
  hlsPlusLimit: number | null;
}

export interface LoginResponse {
  accessToken: string;
  refreshToken: string;
  user: User;
}

export interface LoginPayload {
  email: string;
  password: string;
}

// --- START OF MODIFICATION ---
export interface RegisterPayload {
  email: string;
  password: string;
  phone: string;
  country: string;
  streamName: string;
  // Add the new role to the payload type
  role: 'BROADCASTER' | 'STREAMR';
}
// --- END OF MODIFICATION ---

export const register = async (payload: RegisterPayload): Promise<void> => {
  await api.post('/auth/register', payload);
};

export const login = async (payload: LoginPayload): Promise<LoginResponse> => {
  const { data } = await api.post<LoginResponse>('/auth/login', payload);
  setTokens(data.accessToken, data.refreshToken);
  return data;
};

export const getMe = async (): Promise<User> => {
  const { data } = await api.get<User>('/users/me');
  return data;
};

export const logout = async (): Promise<void> => {
  const refreshToken = getRefreshToken();
  if (refreshToken) {
    try {
      await api.post('/auth/logout', { refresh: refreshToken });
    } catch (err) {
      console.error("Server logout failed, clearing tokens locally anyway.", err);
    }
  }
  clearTokens();
  window.location.href = '/login'; 
};

export const sendPasswordResetEmail = async (email: string): Promise<{ message: string }> => {
  const { data } = await api.post('/auth/forgot-password', { email });
  return data;
};

export const resetPassword = async (token: string, password: string): Promise<{ message: string }> => {
  const { data } = await api.post('/auth/reset-password', { token, password });
  return data;
};
